import {
    createOverlayComponent,
    IOverlayProperties,
} from '@vfde-brix-ws10/overlay';

import {
    ID_WEBCHAT_INPUT_PANEL,
    ID_WEBCHAT_OUTPUT,
    ID_WEBCHAT_HEADER,
} from '../container/Ui/constants';

/**
 * Overlay implementation
 *
 */
export const mountOverlay = (onClose: () => void) => {
    const properties: IOverlayProperties = {
        optAnimation: 'slide',
        optCloseButtonStyle: 'no-shaping',
        optStayOpenOnClickOutside: true,
        business: {
            onClose,
            onOpen: (overlay) => {

            },
        },
    };

    return createOverlayComponent(document.getElementById('webchat-container'), properties);
};

/**
 * open overlay and start webchat
 * @param webchatConfig
 * @param disconnect
 */
export const renderAndOpenOverlay = (disconnect: () => void) => {
    const webchatTemplate = require('./webchat.hbs');
    const webchatTemplateHtml = webchatTemplate({
        idWebChatHeader: ID_WEBCHAT_HEADER,
        idWebchatOutput: ID_WEBCHAT_OUTPUT,
        idWebchatInputPanel: ID_WEBCHAT_INPUT_PANEL,
    });

    const overlay = mountOverlay(() => {
        // if overlay is closed, disconnect webchat session
        disconnect();
    });

    overlay.injectContent(webchatTemplateHtml);
    overlay.open();
};
